import { SB } from '@play-co/replicant';

export const bundleSaleSchema = {
  bundleSale: SB.object({
    // List of purchased items in current event
    purchased: SB.array(SB.string()),
    // Timestamp of the last purchase
    lastPurchasedAt: SB.number(),
  }).optional(),
};
